module.exports = __webpack_public_path__ + "img/course-nature.bb180db5.png";